import React from 'react'
import { useQuery } from '@apollo/client'

import { ContentLoaderTableOnly } from '../../../components/loader/loader.component'
import TableComponent from '../../../components/table/table.component'
import LabelComponent from '../../../components/label/label.component'
import LinkComponent from '../../../components/link/link.component'

import { ActionContainer, SortingContainer } from '../admin.styles'

import { GET_ROOM_LIST } from '../../../config/graphql'

const RoomList = ({ dateRange, groupFilter }) => {
    console.log({ variables: {} })
    const { loading, data } = useQuery(GET_ROOM_LIST, { variables: {} });
    console.log(data);
    const dataRoom = data?.rooms || [];
    console.log(dataRoom);

    if (loading && !dataRoom.length) {
      return <ContentLoaderTableOnly />
    } else {
      var idx = 0;
      return <div>
        <TableComponent mode='custom' template='1fr 2fr 2fr 4fr 2fr 4fr 4fr 2fr 4fr'>
          <div aria-label='head'>
            <div>
              <SortingContainer>No</SortingContainer>
            </div>
            <div>
              <SortingContainer>Blok</SortingContainer>
            </div>
            <div>
              <SortingContainer>No Kamar</SortingContainer>
            </div>
            <div>
              <SortingContainer>Nama Siswa</SortingContainer>
            </div>
            <div>
              <SortingContainer>Kelas Siswa</SortingContainer>
            </div>
            <div>
              <SortingContainer>Status</SortingContainer>
            </div>
            <div>
              <SortingContainer>BM Pembina Siswa</SortingContainer>
            </div>
            <div>
              <SortingContainer>Kapasitas Kamar</SortingContainer>
            </div>
            <div>
              <SortingContainer>BM Pengawas Kamar</SortingContainer>
            </div>
          </div>
          <div aria-label='body'>
            {dataRoom.flatMap((room) => {
                return room.currentReservations.map((reservation) => {
                  idx++;
                  return (
                    <div key={idx}>
                      <div>
                        <LabelComponent mode='tagredmobile'>NO</LabelComponent>
                        {idx}
                      </div>
                      <div>
                        <LabelComponent mode='tagredmobile'>Blok</LabelComponent>
                        {(room.group.name)}
                      </div>
                      <div>
                        <LabelComponent mode='tagredmobile'>No Kamar</LabelComponent>
                        {(room.roomNumber)}
                      </div>
                      <div>
                        <LabelComponent mode='tagredmobile'>Nama Siswa</LabelComponent>
                        {(reservation.student.name)}
                      </div>
                      <div>
                        <LabelComponent mode='tagredmobile'>Kelas Siswa</LabelComponent>
                        {(reservation.student.classroom.name)}
                      </div>
                      <div>
                        <LabelComponent mode='tagredmobile'>Status</LabelComponent>
                        {(reservation.status.name)}
                      </div>
                      <div>
                        <LabelComponent mode='tagredmobile'>BM Pembina Siswa</LabelComponent>
                        {(reservation.student?.boardingMasterMentor?.teacher?.name)}
                      </div>
                      <div>
                        <LabelComponent mode='tagredmobile'>Kapasitas Kamar</LabelComponent>
                        {(room.totalBeds)}
                      </div>
                      <div>
                        <LabelComponent mode='tagredmobile'>BM Pengawas Kamar</LabelComponent>
                        {(room.boardingMaster?.name)}
                      </div>
                    </div>
                  )
                })
            })}
          </div> 
        </TableComponent>
      </div>
    }
}

export default RoomList;